import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import PublicLayout from "@/components/PublicLayout";
import { UploadSimple, Sparkle, MapPin, Broadcast, ArrowRight } from "@phosphor-icons/react";

const STEPS = [
  { icon: UploadSimple, title: "1. Upload or import", body: "Add a single photo, pick up to 10 from your phone, or import an entire archive in the background. (Edit this text.)" },
  { icon: Sparkle, title: "2. AI does the work", body: "Every photo is analysed for its subject and scene, and a title & description are drafted automatically — right after upload, never blocking you. (Edit this text.)" },
  { icon: MapPin, title: "3. Placed on the map", body: "GPS and EXIF are read and reverse-geocoded so each photo knows where it was taken, with a confidence level you can confirm. (Edit this text.)" },
  { icon: Broadcast, title: "4. Shared with the network", body: "Choose how each photo can be reused, then publish it to the public gallery and the SocialPulse media API. (Edit this text.)" },
];

const Section = ({ eyebrow, title, children }) => (
  <section className="mx-auto max-w-3xl px-5 py-10">
    <p className="overline text-[#F27A54]">{eyebrow}</p>
    <h2 className="mt-1 font-display text-2xl font-black tracking-tight">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-zinc-600">{children}</div>
  </section>
);

export default function About() {
  useSeo({ title: "How it works — PhotoPulse.pro", description: "How PhotoPulse.pro turns your photo library into a living, AI-organised, mapped gallery shared across the SocialPulse network." });
  return (
    <PublicLayout>
      <section className="mx-auto max-w-4xl px-5 py-16 text-center">
        <p className="overline text-[#F27A54]">How it works</p>
        <h1 className="mt-2 font-display text-4xl font-black leading-tight tracking-tight sm:text-5xl">
          From camera roll to a living library
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground">
          PhotoPulse rescues the photos most people never share. Here's the journey each one takes.
          <br /><span className="text-xs">(This is placeholder copy — replace it with your article intro.)</span>
        </p>
      </section>

      <section className="mx-auto grid max-w-4xl gap-4 px-5 sm:grid-cols-2">
        {STEPS.map((s) => (
          <div key={s.title} className="rounded-xl border border-border bg-white p-6">
            <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#F27A54] text-white"><s.icon size={22} weight="fill" /></span>
            <h3 className="mt-4 font-display text-lg font-bold">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-zinc-600">{s.body}</p>
          </div>
        ))}
      </section>

      <Section eyebrow="Our mission" title="Why we built this">
        <p>Replace this section with your article. A phone is the cemetery of photos that never get seen — PhotoPulse exists to bring the best of them back to life, organised and shared so they can be discovered, enjoyed and reused across the Pulse network.</p>
        <p>Add as many paragraphs as you like. This page is a ready-made home for your long-form story.</p>
      </Section>

      <Section eyebrow="For the network" title="A shared media layer">
        <p>Every public photo becomes available to sister sites (TravelerPulse, NaturePulse, and more) through a structured media API — with the reuse permissions each contributor chose. (Edit this text.)</p>
      </Section>

      <div className="mx-auto max-w-3xl px-5 pb-16">
        <div className="rounded-xl bg-[#F27A54] p-6 text-center text-white">
          <p className="font-display text-lg font-bold">Ready to add yours?</p>
          <div className="mt-4 flex flex-wrap justify-center gap-3">
            <Link to="/explore" className="rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#F27A54] hover:bg-white/90">Explore the gallery</Link>
            <Link to="/login" className="flex items-center gap-1.5 rounded-full bg-white/15 px-5 py-2.5 text-sm font-bold backdrop-blur hover:bg-white/25">Contribute <ArrowRight size={14} weight="bold" /></Link>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
